import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

interface LinkWithIconProps {
    to: string;
    linkTitle: string;
    hasPermissions: boolean;
}

export function LinkWithIcon({ to, linkTitle, hasPermissions }: LinkWithIconProps) {
    return hasPermissions ? (
        <Link
            to={to}
            className="text-primary-700 hover:text-primary-600 overflow-wrap-normal cursor-pointer font-medium break-keep whitespace-normal"
        >
            {linkTitle}
            <FontAwesomeIcon icon={faArrowUpRight} />
        </Link>
    ) : (
        <div className="whitespace-nowrap">{linkTitle ?? '-'}</div>
    );
}
